import { useBeautySimulator } from "./useBeautySimulator";

export function BeautyCalculator() {
  const simulator = useBeautySimulator();

  return (
    <section className="calc-sec">
      <div className="calc-inner">
        <div className="calc-left">
          <div className="sec-kicker">Quanto você perde?</div>
          <h2 className="sec-h">Calcule sua perda<br />com faltas sem aviso.</h2>
          <p className="sec-sub">
            Escolha um porte parecido com o seu e ajuste os números. Quanto maior a equipe, mais a agenda precisa de controle para evitar horários vazios.
          </p>
        </div>
        <div className="calc-card">
          <div className="calc-size-block">
            <div className="calc-label size-title">
              Porte da operação
              <strong>{simulator.selectedSize.professionals} profissional{simulator.selectedSize.professionals > 1 ? "s" : ""}</strong>
            </div>
            <div className="size-options" role="list" aria-label="Porte da operação">
              {simulator.sizes.map((size) => (
                <button
                  className={`size-option${simulator.selectedSizeId === size.id ? " active" : ""}`}
                  type="button"
                  key={size.id}
                  onClick={() => simulator.selectSimulatorSize(size)}
                  aria-pressed={simulator.selectedSizeId === size.id}
                >
                  <span>{size.label}</span>
                  <strong>{size.professionals} prof.</strong>
                  <small>{size.description}</small>
                </button>
              ))}
            </div>
          </div>
          <label className="calc-row">
            <span className="calc-label">Atendimentos por mês <strong>{simulator.appointments}</strong></span>
            <input className="calc-slider" type="range" min="20" max="1400" step="10" value={simulator.appointments} onChange={(event) => simulator.setAppointments(Number(event.target.value))} />
          </label>
          <label className="calc-row">
            <span className="calc-label">Ticket médio por serviço <strong>R$ {simulator.ticket}</strong></span>
            <input className="calc-slider" type="range" min="40" max="700" step="10" value={simulator.ticket} onChange={(event) => simulator.setTicket(Number(event.target.value))} />
          </label>
          <label className="calc-row">
            <span className="calc-label">Faltas sem aviso estimadas <strong>{simulator.absenceRate}%</strong></span>
            <input className="calc-slider" type="range" min="5" max="50" value={simulator.absenceRate} onChange={(event) => simulator.setAbsenceRate(Number(event.target.value))} />
          </label>
          <div className="calc-mini-grid">
            <div>
              <span>{simulator.missedAppointments}</span>
              horários vazios/mês
            </div>
            <div>
              <span>R$ {simulator.annualLoss.toLocaleString("pt-BR")}</span>
              perda estimada/ano
            </div>
          </div>
          <div className="calc-result">
            <div className="calc-result-label">Perda estimada por mês</div>
            <div className="calc-result-val">R$ {simulator.monthlyLoss.toLocaleString("pt-BR")}</div>
            <div className="calc-result-sub">
              Em um cenário conservador, evitar 30% dessas faltas preservaria cerca de R$ {simulator.recoveredEstimate.toLocaleString("pt-BR")}/mês.
            </div>
          </div>
          <a className="calc-cta" href="/go/start">Quero proteger minha agenda -&gt;</a>
        </div>
      </div>
    </section>
  );
}
